import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { getToken } from "../../../utils/tokenService";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ClientOfferLetters = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const token = await getToken();
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/client/offer-letters`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setEmployees(res.data?.employees || []);
      } catch (err) {
        toast.error("Failed to load offer letters");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleView = (emp) => {
    const offerLetterId =
      emp.hired?.offerLetterId?._id || emp.hired?.offerLetterId;
    if (!offerLetterId) {
      toast.info("No offer letter is available for this employee yet.");
      return;
    }
    navigate(`/client_dashboard/offer-letter/${offerLetterId}`);
  };

  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Offer Letters</h4>
        <span className="text-muted small">{employees.length} employees</span>
      </div>
      {!employees.length ? (
        <p className="text-muted">No employees found for this client.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle">
            <thead className="table-light">
              <tr>
                <th>Employee ID</th>
                <th>Name</th>
                <th>Contact</th>
                <th>Email</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp) => (
                <tr key={emp._id}>
                  <td>{emp.employeeId ? `CMPL${emp.employeeId}` : "N/A"}</td>
                  <td className="fw-semibold">{emp.full_Name || "N/A"}</td>
                  <td>{emp.contact || "-"}</td>
                  <td>{emp.email || "-"}</td>
                  <td>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handleView(emp)}
                    >
                      <FaEye className="me-1" />
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ClientOfferLetters;
